import React, { Fragment } from "react";
import "./DefaultFooter.scss";

const DefaultFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer>
        <nav>
          <span className="my-auto copyright-text">
            {" "}
            ©SigmaStream - Veras DQAgent | {currentYear}
          </span>
        </nav>
      </footer>
    </>
  );
};

export default DefaultFooter;
